import { create } from "zustand";
import { IdBasedLookup, fetchCatTools } from "api/lookups.api";

interface CatToolsState {
  catTools: IdBasedLookup[];
  isLoaded: boolean;
  loadCatTools: () => Promise<void>;
  getCatToolName: (catToolId: number) => string | null;
}

export const useCatToolsStore = create<CatToolsState>((set, get) => ({
  catTools: [],
  isLoaded: false,
  loadCatTools: async () => {
    if (get().isLoaded) return;
    const catTools = await fetchCatTools();
    set({ catTools, isLoaded: true });
  },
  getCatToolName: (catToolId: number) => {
    const { catTools } = get();
    return catTools.find((ct) => Number(ct.id) === catToolId)?.description ?? null;
  },
}));
